module.exports = __webpack_public_path__ + "img/D202102_1.218c32b0.jpg";